
	import { Inject, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import Component from 'vue-class-component';
	import postingOptions from '@/store/prescription/definition/categories/postingOptions';
	import PrescriptionItemSelectLR from '@/components/new-prescription/prescription-items/PrescriptionItemSelectLR.vue';
	import CategoryContainer from '@/components/new-prescription/prescription-categories/CategoryContainer.vue';
	import PrescriptionItemExtendedSelectLR from '@/components/new-prescription/prescription-items/PrescriptionItemExtendedSelectLR.vue';
	import { PrescriptionEventHandler } from '@/components/new-prescription/PrescriptionForm.vue';
	import PrescriptionItemRadio from '@/components/new-prescription/prescription-items/PrescriptionItemRadio.vue';

	@Observer
	@Component({
		components: { PrescriptionItemExtendedSelectLR, PrescriptionItemSelectLR, PrescriptionItemRadio, CategoryContainer }
	})
	export default class PostingOptions extends Vue {
		@Inject() eventHandler!: PrescriptionEventHandler;

		get posting() {
			return postingOptions;
		}

		private init() {
			this.eventHandler.addEventHandler(this.$state.prescription.newPrescription.postingOptions.rearfootPost, 'override', ['none'], () => {
				this.$state.prescription.newPrescription.postingOptions.rearfootPostUndercut = undefined;
				// this.$state.prescription.newPrescription.postingOptions.forefootPost.override = 'intrinsic';
			});

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.postingOptions.lateralHeelSkive,
				'left',
				['2mm', '4mm', '6mm', '8mm'],
				() => {
					this.$state.prescription.newPrescription.postingOptions.medialHeelSkive.left = '0mm';
				}
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.postingOptions.lateralHeelSkive,
				'right',
				['2mm', '4mm', '6mm', '8mm'],
				() => {
					this.$state.prescription.newPrescription.postingOptions.medialHeelSkive.right = '0mm';
				}
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.postingOptions.medialHeelSkive,
				'left',
				['2mm', '4mm', '6mm', '8mm'],
				() => {
					this.$state.prescription.newPrescription.postingOptions.lateralHeelSkive.left = '0mm';
				}
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.postingOptions.medialHeelSkive,
				'right',
				['2mm', '4mm', '6mm', '8mm'],
				() => {
					this.$state.prescription.newPrescription.postingOptions.lateralHeelSkive.right = '0mm';
				}
			);

			this.eventHandler.addEventHandler(
				this.$state.prescription.newPrescription.postingOptions.rearfootPost,
				'override',
				['lab-specifies', 'specify'],
				(val, prev) => {
					if (this.$state.prescription.newPrescription.postingOptions.rearfootPostUndercut === undefined) {
						this.$state.prescription.newPrescription.postingOptions.rearfootPostUndercut = 'standard';
					}
					if (this.$state.prescription.newPrescription.postingOptions.forefootPost.override === 'none') {
						if (!((val === 'lab-specifies' && prev === 'specify') || (val === 'specify' && prev === 'lab-specifies'))) {
							this.$state.prescription.newPrescription.postingOptions.forefootPost.override = 'balance';
						}
					}
				}
			);
		}

		created() {
			this.eventHandler.addInitializationFunction(this.init.bind(this.eventHandler));
		}
	}
